import { contentNameSelectLabel, genderOptions } from '../constants';

export function transformContentfulCreatives(creatives, previousCreatives) {
  if (!creatives?.clmContentPreview) return [];

  const previousContentIds = previousCreatives
    ? previousCreatives.map(creative => creative.contentId)
    : [];
  const previousCreativesLength = previousContentIds.length;

  // Remove creatives already stored to not mess up the content id index
  const uniqueCreatives = Object.entries(creatives.clmContentPreview).filter(
    ([contentId, data]) => !previousContentIds.includes(contentId), // eslint-disable-line no-unused-vars
  );

  return uniqueCreatives.map(([contentId, data], index) => {
    const imageCreatives = data.cover_image_data || [];
    const videoCreatives = data.cover_video_data || [];

    const allGenders = genderOptions.map(gender => gender.value);
    const uniqueGenders = new Set(
      [...imageCreatives, ...videoCreatives].map(item => item.target_group),
    );

    // Remove duplicated genders
    const genders = uniqueGenders.has('ALL') ? allGenders : [...uniqueGenders];

    // Remove duplicated countries
    const countryCodes = [
      ...new Set(
        [...imageCreatives, ...videoCreatives].map(item => item.country_code),
      ),
    ];

    // Choose the first Creative to display
    const imageUrl =
      imageCreatives.length > 0
        ? imageCreatives[0].url
        : videoCreatives[0]?.url;

    return {
      contentIdIndex: index + previousCreativesLength,
      contentId,
      genders,
      imageUrl,
      countryCodes,
      productIds: undefined,
      productTags: [],
      categories: [],
      contentName: data.content_name,
      supportedProductCodes: data.product_codes || [],
    };
  });
}

export function storeNewContentfulCreative(
  storedCreatives,
  additionalCreatives,
) {
  const storedCreativesList = [...storedCreatives];

  const transformedAdditionalCreatives = transformContentfulCreatives(
    additionalCreatives,
    storedCreativesList,
  );

  transformedAdditionalCreatives.forEach(additionalCreative => {
    const isAdditionalCreativeOnList = storedCreativesList.some(
      storedCreative =>
        storedCreative.contentId === additionalCreative.contentId,
    );
    if (!isAdditionalCreativeOnList) {
      storedCreativesList.push(additionalCreative);
    }
  });

  return storedCreativesList;
}

export const addIndexToContentfulCreatives = creatives =>
  creatives.map((creative, index) => ({ contentIdIndex: index, ...creative }));

export function getContentIdOptions(entities) {
  return entities.map(entity => ({
    label: contentNameSelectLabel(entity),
    value: entity.content_id,
    data: entity,
  }));
}
